import { PlusIcon } from '@phosphor-icons/react';
import './styles.scss';

const ItemAction = ({ onActionClick }) => {
    return (
        <div className="item-action" onClick={(e) => onActionClick(e)}>
            <PlusIcon color="white" size={18} />
        </div>
    )
}

export default ItemAction;